<div class="relative h-full rounded-lg overflow-hidden border border-gray-200">
  @if (apiLoaded() === null) {
    <div class="flex items-center justify-center h-full">
      <ui-loading-spinner />
    </div>
  } @else if (apiLoaded() === false) {
    <div class="flex items-center justify-center h-full text-text-secondary">
      <p>Unable to load map</p>
    </div>
  } @else {
    <google-map [options]="mapOptions()" [center]="center()" height="100%" width="100%" class="h-full w-full">
      <map-marker [position]="center()" [options]="markerOptions()" />
    </google-map>
  }
</div>
